var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57202 2.57612C8.57303 2.57612 9.3842 3.38729 9.3842 4.38831C9.3842 5.38933 8.57303 6.20049 7.57202 6.20049C6.571 6.20049 5.75983 5.38933 5.75983 4.38831C5.75983 3.38729 6.571 2.57612 7.57202 2.57612ZM7.57202 10.3427C10.1349 10.3427 12.836 11.6026 12.836 12.1548V13.1041H2.30805V12.1548C2.30805 11.6026 5.00907 10.3427 7.57202 10.3427ZM7.57202 0.936523C5.66491 0.936523 4.12024 2.4812 4.12024 4.38831C4.12024 6.29542 5.66491 7.84009 7.57202 7.84009C9.47913 7.84009 11.0238 6.29542 11.0238 4.38831C11.0238 2.4812 9.47913 0.936523 7.57202 0.936523ZM7.57202 8.70304C5.26795 8.70304 0.668457 9.85938 0.668457 12.1548V14.7437H14.4755V12.1548C14.4755 9.85938 9.87608 8.70304 7.57202 8.70304Z",
    fill: "url(#paint0_linear_235_10719)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_10719",
    x1: 0.668457,
    y1: 14.7437,
    x2: 15.062,
    y2: 1.57762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0854,
    stopColor: "#539B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#7CB940"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.edee4f91f60cb28883fc92c9dcaf413c.svg";
export { ForwardRef as ReactComponent };